import React, { lazy } from "react";

const FLAG = "omni_chunk_reload";

// Load a screen only when it's opened. After a new deploy an open tab may ask for a file that no longer exists — reload once to pick up the new build.
export const lazyPage = (load) => lazy(() => load()
  .then((m) => { sessionStorage.removeItem(FLAG); return m; })
  .catch((e) => {
    if (!sessionStorage.getItem(FLAG)) {
      sessionStorage.setItem(FLAG, "1");
      window.location.reload();
      return new Promise(() => {});
    }
    throw e;
  }));

export const PageLoading = ({ full = false }) => (
  <div className={`${full ? "min-h-screen" : "min-h-[40vh]"} flex items-center justify-center`} data-testid="page-loading">
    <div className="font-mono text-xs uppercase tracking-widest text-muted-foreground animate-pulse">Loading…</div>
  </div>
);

// Catches a screen that still can't load (e.g. lost signal) and offers a reload instead of a blank page.
export class PageErrorBoundary extends React.Component {
  constructor(props) { super(props); this.state = { failed: false }; }
  static getDerivedStateFromError() { return { failed: true }; }
  componentDidUpdate(prev) { if (prev.resetKey !== this.props.resetKey && this.state.failed) this.setState({ failed: false }); }
  render() {
    if (!this.state.failed) return this.props.children;
    return (
      <div className="min-h-[40vh] flex flex-col items-center justify-center gap-3 p-6 text-center" data-testid="page-load-error">
        <div className="text-base font-semibold">This screen didn't load — check your connection.</div>
        <button type="button" onClick={() => { sessionStorage.removeItem(FLAG); window.location.reload(); }} className="px-4 py-2 border border-current font-semibold" style={{ borderRadius: 8 }} data-testid="page-load-retry">Reload</button>
      </div>
    );
  }
}
